
    import { Component, Vue } from 'vue-property-decorator'

    export default class Error extends Vue {
    }
